import useAccount from "authentication/_hooks/useAccount";

const useAccountTerm = () => useAccount().authenticatedAccount ? "Nutzerkonto" : "Gastkonto";
export default useAccountTerm;